module.exports.title = '${num_of_books} Book Recommendations by ${influencer} (Updated Daily)'
module.exports.description = 'Book recommendations by ${influencer} with recommendations'
module.exports.image = '${image}'
module.exports.heading = '${num_of_books} Book Recommendations by ${influencer}'